import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from "antd";
import { TagOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { InfoWindow } from '../../components/googleMap';
import './MapInfoWindow.css';
import DateRangeDescription from "../../components/DateRangeDescription";
import VehicleHirePaymentMethod from "../../enums/VehicleHirePaymentMethod";
const MarketplaceClusterInfoWindow = ({ markers, position, visible, onClose, onConsignmentMarkerClick, onVehicleHireMarkerClick }) => {
    const renderDivForMarker = (marker) => {
        if (marker.data.consignmentRef) {
            return renderConsignmentDiv(marker);
        }
        if (marker.data.ref) {
            return renderVehicleHireDiv(marker);
        }
        return null;
    };
    const renderConsignmentDiv = (marker) => {
        const consignment = marker.data;
        return (_jsxs("div", { className: "job-summary", children: [_jsx("hr", {}), _jsx(TagOutlined, {}), _jsxs("div", { className: "job-details", children: [consignment.tenant.name, " - ", consignment.consignmentRef, _jsx("br", {}), consignment.pickupAddress.suburb, " ", '->', " ", consignment.deliveryAddress.suburb, _jsx("br", {}), _jsx(Button, { htmlType: "button", onClick: () => onConsignmentMarkerClick(marker), children: "View" }), _jsx(DateRangeDescription, { fromISOTimestamp: consignment.deliveryFrom, toISOTimestamp: consignment.deliveryTo })] })] }, "C" + consignment.id));
    };
    const renderVehicleHireDiv = (marker) => {
        const vehicleHire = marker.data;
        return (_jsxs("div", { className: "job-summary", children: [_jsx("hr", {}), _jsx(FontAwesomeIcon, { icon: faTruck }), _jsxs("div", { className: "job-details", children: [vehicleHire.tenant.name, " - ", vehicleHire.preferredVehicleType.description, _jsx("br", {}), "Hire: " + VehicleHirePaymentMethod.valueOf(vehicleHire.paymentMethod)?.fullDescription, _jsx("br", {}), _jsx(Button, { htmlType: "button", onClick: () => onVehicleHireMarkerClick(marker), children: "View" }), _jsx(DateRangeDescription, { fromISOTimestamp: vehicleHire.hireFrom, toISOTimestamp: vehicleHire.hireTo })] })] }, "V" + vehicleHire.id));
    };
    return (_jsx(InfoWindow, { position: position, visible: visible, onClose: onClose, children: markers &&
            _jsxs("div", { className: "marketplace-info-window", children: [_jsxs("h4", { children: [markers.length, " jobs at this location"] }), markers.map(renderDivForMarker)] }) }, "MarketplaceClusterInfoWindow"));
};
export default MarketplaceClusterInfoWindow;
